import React from 'react'

export const Shows = React.createContext({})
export const User = React.createContext({})
export const UploadForm = React.createContext({})
